import Seo from "../components/common/Seo";
import PageHeader from "../components/common/PageHeader";
import { company } from "../lib/content";

const updated = "June 2026";

const content = {
  privacy: {
    title: "Privacy Policy",
    eyebrow: "Legal",
    intro: "How Kratos Venture Group handles information submitted through this website.",
    sections: [
      { h: "Information we collect", p: "We collect the information you voluntarily provide through our contact and strategy-call form, such as your name, work email, phone number, company details, and message." },
      { h: "How we use information", p: "We use submitted information to respond to your request, schedule strategy sessions, and communicate about our services. We do not sell your information." },
      { h: "Data storage", p: "Lead submissions are stored in this project's own isolated database. Email notifications are sent through this project's own configured email service." },
      { h: "Third-party services", p: "Depending on configuration, we may use approved third-party providers to deliver notifications and operate the site. These providers process data under their own terms." },
      { h: "Your choices", p: "You may request access to, correction of, or deletion of the information you submitted by contacting us." },
      { h: "Contact", p: `For privacy questions, contact ${company.email}.` },
    ],
  },
  terms: {
    title: "Terms of Use",
    eyebrow: "Legal",
    intro: "The terms that govern your use of this website.",
    sections: [
      { h: "Acceptance of terms", p: "By accessing this website, you agree to these terms of use. If you do not agree, please do not use the site." },
      { h: "Use of content", p: "All content, branding, and materials on this site are the property of Kratos Venture Group and may not be reproduced without permission." },
      { h: "No warranties", p: "This website and its content are provided on an as-is basis. Descriptions of services and products are informational and subject to change." },
      { h: "Limitation of liability", p: "Kratos Venture Group is not liable for any damages arising from the use of this website to the extent permitted by law." },
      { h: "Changes", p: "We may update these terms at any time. Continued use of the site constitutes acceptance of the updated terms." },
      { h: "Contact", p: `For questions about these terms, contact ${company.email}.` },
    ],
  },
  accessibility: {
    title: "Accessibility",
    eyebrow: "Commitment",
    intro: "Our approach to making this website usable for everyone.",
    sections: [
      { h: "Our commitment", p: "We are committed to providing an accessible experience and aim to align with recognized accessibility guidance." },
      { h: "Measures we take", p: "The site uses semantic structure, keyboard-navigable controls, visible focus states, contrast-aware colour, and honours reduced-motion preferences." },
      { h: "Motion & animation", p: "Where motion is used, users who prefer reduced motion receive a lighter, static experience automatically." },
      { h: "Ongoing effort", p: "Accessibility is an ongoing effort. We continue to review and improve the experience over time." },
      { h: "Feedback", p: `If you encounter an accessibility barrier, please contact ${company.email} so we can address it.` },
    ],
  },
};

export default function LegalPage({ type }) {
  const c = content[type];
  return (
    <>
      <Seo title={`${c.title} — Kratos Venture Group`} description={c.intro} path={`/${type === "privacy" ? "privacy-policy" : type === "terms" ? "terms-of-use" : "accessibility"}`} />
      <PageHeader eyebrow={c.eyebrow} title={c.title} intro={c.intro} />
      <section className="relative py-16 md:py-24" data-testid={`legal-${type}`}>
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <p className="font-mono text-[11px] uppercase tracking-[0.16em] text-kv-steel mb-10">Last updated — {updated}</p>
          <div className="space-y-10">
            {c.sections.map((s) => (
              <div key={s.h}>
                <h2 className="font-display text-xl md:text-2xl font-medium tracking-tight text-kv-off">{s.h}</h2>
                <p className="mt-3 font-body text-sm md:text-base text-kv-grey leading-relaxed">{s.p}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
